import { createStyles } from "@mantine/emotion";
import { rem } from "@mantine/core";

export const useStylesButton = createStyles((theme) => {
  return {
    buttonBlack: {
      backgroundColor: theme.customBackgrounds.blackPrimary,
      color: theme.customColors.white,
      fontSize: "1.2em",
      border: "1px solid " + theme.customBackgrounds.blackPrimary,
      "&:hover": {
        backgroundColor: theme.customColors.white,
        color: theme.customColors.black,
      },
    },
    buttonBlackHeader: {
      backgroundColor: theme.customBackgrounds.blackPrimary,
      borderRadius: theme.spacing.button.header.borderRadius,
      border: theme.customColors.headerButtonBorder,
      fontSize: theme.spacing.button.header.fontSize,
      padding: theme.spacing.button.header.padding,
    },
    buttonBlackHeaderMobile: {
      backgroundColor: theme.customBackgrounds.blackPrimary,
      borderRadius: theme.spacing.button.header.borderRadius,
      border: theme.customColors.headerButtonBorder,
      fontSize: theme.spacing.button.header.fontSize,
      height: theme.spacing.button.header.mobile.height,
      padding: theme.spacing.button.header.mobile.padding,
    },
    buttonWhite: {
      backgroundColor: theme.customColors.white,
      color: theme.customColors.black,
      fontSize: "1.2em",
      border: "1px solid " + theme.customColors.black,
      "&:hover": {
        backgroundColor: theme.customBackgrounds.blackPrimary,
        color: theme.customColors.white,
      },
    },
    buttonWhiteHeader: {
      borderRadius: theme.spacing.button.header.borderRadius,
      border: theme.customColors.headerButtonBorder,
      fontSize: theme.spacing.button.header.fontSize,
      padding: theme.spacing.button.header.padding,
      "&:hover": {
        backgroundColor: theme.customBackgrounds.blackPrimary,
      },
    },
    buttonWhiteHeaderPlan: {
      borderColor: theme.customColors.black,
    },
    buttonWhiteHeaderMobile: {
      height: theme.spacing.button.header.mobile.height,
      padding: theme.spacing.button.header.mobile.padding,
      borderRadius: theme.spacing.button.header.borderRadius,
      border: theme.customColors.headerButtonBorder,
      fontSize: theme.spacing.button.header.fontSize,
      "&:hover": {
        backgroundColor: theme.customBackgrounds.blackPrimary,
      },
    },
    buttonGreenHover: {
      "&:hover": {
        backgroundColor: theme.customBackgrounds.greenLight,
        color: theme.customColors.black,
      },
    },
    link: {
      fontSize: "1em",
      textDecoration: "underline",
      paddingLeft: "0",
      width: "auto",
      textAlign: "left",
      color: theme.customColors.blackLight,
      "&:hover": {
        textDecoration: "none",
        color: theme.customColors.blackLight,
      },
    },
    linkWidth90: {
      width: "6em",
    },
    linkUserAddressCorrect: {
      [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
        left: "2em",
      },
    },
    iconChevronLeft: {
      width: rem(21),
      height: rem(33),
      stroke: theme.customColors.white,
    },
    anchor: {
      borderRadius: "0.3em",
      padding: "0.5em 1em",
      "&:hover svg": {
        stroke: theme.customColors.black,
      },
    },
    link_padding_0: {
      padding: "0",
    },
    link_black: {
      color: theme.customColors.black,
      fontWeight: "normal",
    },
    linkRed: {
      color: theme.customColors.red,
      fontWeight: "normal",
    },
    tabs: {
      padding: theme.spacing.button.tabs.padding,
      borderRadius: theme.spacing.button.tabs.borderRadius,
      position: "relative",
      button: {
        backgroundColor: theme.customBackgrounds.verifyStampZone,
        color: theme.customColors.tabText,
        fontWeight: "normal",
        fontSize: theme.spacing.button.tabs.item.fontSize,
        paddingLeft: theme.spacing.button.tabs.item.padding,
        paddingRight: theme.spacing.button.tabs.item.padding,
        height: theme.spacing.button.tabs.item.height,
        borderRadius: "0",
        position: "relative",
        boxShadow: "1px 0 0 " + theme.customBackgrounds.button,
        width: theme.spacing.button.tabs.item.width,
        [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
          paddingLeft: theme.spacing.button.tabs.item.mobile.padding,
          paddingRight: theme.spacing.button.tabs.item.mobile.padding,
          height: theme.spacing.button.tabs.item.mobile.height,
          width: theme.spacing.button.tabs.item.mobile.width,
        },
        svg: {
          fill: theme.customBackgrounds.tabsButtonIcon,
          marginRight: theme.spacing.button.tabs.item.icon.margin,
          width: theme.spacing.button.tabs.item.icon.size,
          [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
            width: theme.spacing.button.tabs.item.mobile.icon.size,
            display: "none",
          },
        },
        "&:last-child": {
          boxShadow: "none",
          borderRadius: "0 1.333em 1.333em 0",
        },
        "&:hover": {
          backgroundColor: theme.customBackgrounds.verifyStampZone,
          color: theme.customColors.tabText,
        },
        "&:first-of-type": {
          borderRadius: "1.333em 0 0 1.333em",
        },
        "&.active": {
          backgroundColor: theme.customBackgrounds.button,
          color: theme.customColors.white,
          svg: {
            fill: theme.customColors.white,
          },
        },
        "&.rb-btn-long-csv": {
          zIndex: "1",
        },
        "&.rb-btn-user-found": {
          zIndex: "2",
        },
        "&.rb-btn-hash": {
          zIndex: "3",
        },
        "&.rb-btn-file": {
          zIndex: "4",
        },
        "&.rb-btn-text": {
          zIndex: "1",
        },
      },
    },
  };
});
